import React from 'react';

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

export default class FormCheckbox extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      value: this.props.checked ? this.props.value : '',
      checked: this.props.checked,
      isValid: true
    };
  }

  componentDidMount() {
    this.props.attachToForm(this); // Attaching the component to the form
    if (this.props.value) {
      this.props.validate(this, this.props.value);
    }
    if (this.props.setControlRef) {
      this.props.setControlRef(this.input);
    }
  }

  componentWillUnmount() {
    this.props.detachFromForm(this); // Detaching if unmounting
  }

  updateCheck(checked) {
    const value = checked ? this.props.value : '';
    this.setState({ checked, value: value });
    this.props.validate(this, value);
  }

  render() {
    return (
      <FormControlLabel
        className={this.props.className}
        control={
          <Checkbox
            id={this.props.id}
            name={this.props.id}
            ref={this.props.id}
            onChange={(e, checked) => this.updateCheck(checked)}
            onClick={this.props.handleClick}
            style={this.props.style}
            color="primary"
            checked={this.state.checked}
          />
        }
        label={this.props.label}
      />
    );
  }
}
